import { FieldNames } from 'app/models/fields/names';
import { RadioField } from 'app/components/FormFields/RadioField';
import { COMMERCIAL_LOAN_TYPE_OPTIONS } from 'app/models/options/options';
import { Question } from 'app/models/types';

/**
 * Takes in a field name and returns the corresponding form landing
 * question
 *
 * @param {string} name Field name
 * @returns Question with matching field name
 */
export const commercialQuestionByName = (name: string): Question => {
  return COMMERCIAL_QUESTIONS.find((question) => {
    return question.name === name;
  }) as Question;
};

/**
 * Takes in an array of field names and returns an array of questions
 *
 * @param {string[]} [names=[]] Field names
 * @returns Questions matching field names
 */
export const commercialQuestionsByName = (names: string[] = []): Question[] => {
  const questions: Question[] = [];
  for (const name of names) {
    questions.push(commercialQuestionByName(name));
  }
  return questions;
};

export const COMMERCIAL_QUESTIONS: Question[] = [
  {
    id       : 1001,
    component: RadioField,
    name     : FieldNames.loanType,
    options  : COMMERCIAL_LOAN_TYPE_OPTIONS,
    title    : 'What type of loan would you like?',
  },
];
